import { Guid } from 'src/application/store/model/guid';

import { ItemValidator } from '../../../../../services/ItemValidator';
import { StudentStore } from '../../../../store/models/Store';
import { getItemByIdTypedSelector } from '../../../../store/reducers/items/itemsSelectors';
import { noTrackedItemsSelector } from '../../../../store/reducers/student/tracking/itemsTrackingSelectors';
import { createCompletionServiceSelector } from '../../../tracking/services/CompletionService';
import {
  MenuProjectProgress as Component,
  MenuProjectProgressStateProps,
} from '../../components/student/MenuProjectProgress';
import { isItem, isMenuItem, Item, ItemHelper } from '@ael/core-api';
import { connect } from 'react-redux';

const getCompletableItemsIfTrackingDisabled = (state: StudentStore) =>
  state.items.filter(
    (item: Item) =>
      !ItemHelper.isContentItem(item) &&
      !isMenuItem(item) &&
      isItem(item) &&
      ItemValidator.isValid(item, state.items.toList())
  );

const mapStateToProps = (state: StudentStore): MenuProjectProgressStateProps => {
  const completionService = createCompletionServiceSelector(state);

  const isCompletionTrackingDisabled = noTrackedItemsSelector(state);
  if (isCompletionTrackingDisabled) {
    const completableItems = getCompletableItemsIfTrackingDisabled(state);
    const completedItems = completableItems.filter((item: Item) => {
      const result = completionService.isComplete(item);

      return result;
    });
    const percentage = Math.round((completedItems.size / completableItems.size) * 100);
    return {
      completedPercentage: percentage,
    };
  }

  const completedTrackedItems = state.tracking.items.trackedItems.count((trackedItemId: Guid) => {
    const trackedItem = getItemByIdTypedSelector(state)(trackedItemId, isItem);
    const isComplete = completionService.isComplete(trackedItem);

    return isComplete;
  });

  const percentage = Math.round((completedTrackedItems / state.tracking.items.trackedItems.size) * 100);
  return {
    completedPercentage: percentage,
  };
};

export const MenuProjectProgress = connect(mapStateToProps, null)(Component);
